<template>
  <div 
    class="notification-item" 
    :class="{ 'unread': !notification.read }"
    @click="handleClick"
  >
    <div class="notification-icon">
      <i :class="getIconClass(notification.type)"></i>
    </div>
    
    <div class="notification-content">
      <div class="notification-main">
        <div class="notification-title">
          {{ notification.title }}
          <el-tag v-if="!notification.read" type="primary" size="mini" class="unread-tag">未读</el-tag>
        </div>
        <!-- <div class="notification-message">{{ notification.content }}</div> -->
        <div v-if="notification.content" class="notification-business-data">
          <div class="business-item">
            <div class="business-value-wrapper">
              <div 
                class="business-value content-field" 
                :class="{ 'expanded': isContentExpanded }"
                v-html="formatContent(notification.content)"
              ></div>
              <span 
                v-if="shouldShowContentExpandButton && !isContentExpanded"
                class="expand-button-inline" 
                @click.stop="toggleContent"
              >
                展开
              </span>
              <span 
                v-if="shouldShowContentExpandButton && isContentExpanded"
                class="expand-button-collapse" 
                @click.stop="toggleContent"
              >
                收起
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="notification-meta">
        <span class="notification-time">{{ formatTime(notification.createTime) }}</span>
        <div class="notification-actions-right">
          <el-button 
            v-if="!notification.read"
            type="text" 
            size="mini" 
            @click.stop="handleMarkAsRead"
            class="mark-read-btn"
          >
            标记已读
          </el-button>
          <el-dropdown @command="handleCommand" trigger="click" @click.stop>
            <el-button type="text" size="mini" icon="el-icon-more" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isContentExpanded: false,
      shouldShowContentExpandButton: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkContentHeight()
      
      // 延迟再次检查，确保DOM完全渲染
      setTimeout(() => {
        this.checkContentHeight()
      }, 100)
    })
  },
  watch: {
    'notification.content': {
      handler() {
        this.$nextTick(() => {
          this.checkContentHeight()
        })
      }
    }
  },
  methods: {
    checkContentHeight() {
      const contentElement = this.$el.querySelector('.content-field')
      if (contentElement) {
        const lineHeight = parseFloat(getComputedStyle(contentElement).lineHeight)
        const maxHeight = lineHeight * 3 // 3行的高度
        const actualHeight = contentElement.scrollHeight
        
        // console.log('[NotificationItem] checkContentHeight:', {
        //   lineHeight,
        //   maxHeight,
        //   actualHeight,
        //   shouldShow: actualHeight > maxHeight,
        //   element: contentElement
        // })
        
        this.shouldShowContentExpandButton = actualHeight > maxHeight
      } else {
        // console.warn('[NotificationItem] 未找到.content-field元素')
      }
    },
    formatContent(content) {
      if (!content) return ''
      // 处理换行：将\n转换为<br>，将\r\n转换为<br>
      return content
        .replace(/\r\n/g, '<br>')
        .replace(/\n/g, '<br>')
        .replace(/\r/g, '<br>')
    },
    toggleContent() {
      this.isContentExpanded = !this.isContentExpanded
    },
    expandContent() {
      // 对外暴露的方法，用于从外部触发展开内容
      if (!this.isContentExpanded && this.shouldShowContentExpandButton) {
        this.isContentExpanded = true
      }
    },
    forceCheckContentHeight() {
      // 强制检查内容高度，用于外部调用
      this.$nextTick(() => {
        this.checkContentHeight()
        // 增加多次检查，确保在不同渲染阶段都能正确检测
        setTimeout(() => {
          this.checkContentHeight()
        }, 100)
        setTimeout(() => {
          this.checkContentHeight()
        }, 300)
        setTimeout(() => {
          this.checkContentHeight()
        }, 500)
      })
    },
    handleClick() {
      if (!this.notification.read) {
        this.$emit('mark-as-read', this.notification.id)
      }
    },
    
    handleMarkAsRead() {
      this.$emit('mark-as-read', this.notification.id)
    },
    
    handleCommand(command) {
      switch (command) {
        case 'delete':
          this.$emit('delete', this.notification.id)
          break
      }
    },
    
    getIconClass(type) {
      if (!type) return 'el-icon-bell notification-icon-default'
      
      // 转换为大写以便匹配
      const upperType = String(type).toUpperCase()
      
      const iconMap = {
        'INFO': 'el-icon-info notification-icon-info',
        'WARNING': 'el-icon-warning notification-icon-warning',
        'SUCCESS': 'el-icon-success notification-icon-success',
        'ERROR': 'el-icon-error notification-icon-error'
      }
      return iconMap[upperType] || 'el-icon-bell notification-icon-default'
    },
    
    getPriorityClass(priority) {
      const classMap = {
        'HIGH': 'priority-high',
        'MEDIUM': 'priority-medium',
        'LOW': 'priority-low'
      }
      return classMap[priority] || 'priority-medium'
    },
    
    getPriorityText(priority) {
      const textMap = {
        'HIGH': '高优先级',
        'MEDIUM': '中优先级',
        'LOW': '低优先级'
      }
      return textMap[priority] || '中优先级'
    },
    
    formatTime(time) {
      if (!time) return ''
      const now = new Date()
      const notificationTime = new Date(time)
      const diff = now - notificationTime
      
      if (diff < 60000) { // 1分钟内
        return '刚刚'
      } else if (diff < 3600000) { // 1小时内
        return Math.floor(diff / 60000) + '分钟前'
      } else if (diff < 86400000) { // 1天内
        return Math.floor(diff / 3600000) + '小时前'
      } else {
        return notificationTime.toLocaleDateString()
      }
    }
  }
}
</script>

<style scoped>
.notification-item {
  display: flex;
  padding: 16px 20px;
  border-bottom: 1px solid #F5F7FA;
  cursor: pointer;
  position: relative;
  min-height: 120px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(54, 106, 255, 0.08);
  border-radius: 8px;
  margin: 12px 20px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.notification-item:hover {
  border: 1px solid #366AFF;
  box-shadow: 0 4px 20px 0 rgba(54, 106, 255, 0.15);
  transform: translateY(-2px);
}

.notification-item.unread {
  border-left: 4px solid #366AFF;
  box-shadow: -3px 0 12px rgba(54, 106, 255, 0.2), 0 2px 12px 0 rgba(54, 106, 255, 0.08);
  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
}

.notification-icon {
  margin-right: 12px;
  margin-top: 2px;
  width: 20px;
  text-align: center;
}

.notification-icon-info {
  color: #366AFF;
  font-size: 18px;
}

.notification-icon-warning {
  color: #366AFF;
  font-size: 18px;
}

.notification-icon-success {
  color: #366AFF;
  font-size: 18px;
}

.notification-icon-error {
  color: #366AFF;
  font-size: 18px;
}

.notification-icon-default {
  color: #366AFF;
  font-size: 18px;
}

.notification-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.notification-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.notification-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  line-height: 1.4;
}

.notification-message {
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.notification-business-data {
  /* margin: 8px 0; */
  padding: 8px;
  /* background-color: #F8F9FA; */
  border-radius: 4px;
  font-size: 14px;
}

.business-item {
  display: flex;
  margin-bottom: 4px;
}

.business-item:last-child {
  margin-bottom: 0;
}

.business-label {
  color: #909399;
  margin-right: 8px;
  min-width: 100px;
  flex-shrink: 0;
}

.business-value-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.business-value {
  color: #606266;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.5;
  max-height: 3em;
  transition: max-height 0.3s ease;
  width: 100%;
}

/* Content字段特殊样式 - 最多显示3行 */
.content-field {
  -webkit-line-clamp: 3;
  line-clamp: 3;
  max-height: 4.5em; /* 3行的高度 */
  white-space: pre-wrap; /* 保持换行和空格 */
  word-wrap: break-word; /* 长单词换行 */
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.content-field.expanded {
  -webkit-line-clamp: unset;
  line-clamp: unset;
  max-height: none;
  overflow: visible;
  display: block;
}

/* 内联展开按钮样式 */
.expand-button-inline {
  color: #366AFF;
  font-size: 12px;
  cursor: pointer;
  margin-left: 4px;
  padding: 0 4px;
  border-radius: 2px;
  transition: all 0.3s ease;
  user-select: none;
  display: inline;
  background: linear-gradient(to right, transparent 0%, #f8f9fa 20%, #f8f9fa 100%);
  position: absolute;
  right: 0;
  bottom: 0;
  padding-left: 8px;
}

.expand-button-inline:hover {
  background-color: #f0f9ff;
  transform: scale(1.05);
}

/* 收起按钮样式 */
.expand-button-collapse {
  color: #366AFF;
  font-size: 12px;
  cursor: pointer;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  user-select: none;
  display: block;
  text-align: center;
  background-color: #f8f9fa;
  border: 1px solid #e0e6f7;
}

.expand-button-collapse:hover {
  background-color: #f0f9ff;
  transform: scale(1.05);
}

.business-value.expanded {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  max-height: none;
  overflow: visible;
}

.expand-button {
  color: #366AFF;
  font-size: 12px;
  cursor: pointer;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  user-select: none;
}

.expand-button:hover {
  background-color: #f0f9ff;
  transform: scale(1.05);
}

.notification-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}

.notification-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mark-read-btn {
  color: #366AFF !important;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.mark-read-btn:hover {
  background-color: #f0f9ff;
  color: #366AFF !important;
  transform: scale(1.05);
}

.unread-tag {
  background-color: #366AFF !important;
  border-color: #366AFF !important;
  color: white !important;
  font-size: 10px;
  /* padding: 2px 6px; */
  border-radius: 10px;
  font-weight: 500;
}

.priority-high {
  color: #F56C6C;
  font-weight: 500;
}

.priority-medium {
  color: #E6A23C;
  font-weight: 500;
}

.priority-low {
  color: #67C23A;
  font-weight: 500;
}

.notification-actions {
  margin-left: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}

.notification-item:hover .notification-actions {
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .notification-item {
    padding: 8px 12px;
  }
  
  .notification-actions {
    opacity: 1;
  }
  
  .notification-message {
    -webkit-line-clamp: 1;
    line-clamp: 1;
  }
}
</style>
